/* eslint sort-imports: 0, no-new: 0,  */
import axios from 'axios'
import Dinero from 'dinero.js'
import Vue from 'vue'
import store from './store/store'
import VueHtmlToPaper from 'vue-html-to-paper'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import VueI18nFilter from 'vue-i18n-filter'
import messages from './i18n/messajes'
import dayjs from 'dayjs'
import router from './router'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'
import capitalize from 'lodash/capitalize'
//import VueHighcharts from 'vue-highcharts'
import formatnumber from './plugins/formatnumber'
import './plugins/vuetify'

Vue.prototype.$http = axios
Vue.prototype.$time = dayjs
Vue.prototype.$formatnumber = formatnumber

Vue.use(VueI18n)
Vue.use(VueI18nFilter)
//Vue.use(VueHighcharts)
Vue.use(VueClipboard)

Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ['https://dashboard.trawlingweb.com/api/public/print.css']
})

Vue.use(VueAnalytics, {
  id: 'UA-113376867-1',
  router
})

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

Vue.filter('currency', amount => {
  if (amount) return Dinero({ amount, currency: 'EUR' }).toFormat('0,0.00')
  else return '0.00'
})

Vue.filter('capitalize', text => {
  if (text) return capitalize(text)
  else ''
})

Vue.filter('formatnumber', formatnumber)

Vue.filter('datetime', date => {
  return dayjs(date).format('DD/MM/YYYY, hh:mm:ss')
})

Vue.filter('date', date => {
  return dayjs(date).format('DD/MM/YYYY')
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
